export type CurrencyType = "USD" | "EUR" | "CHF";

export const EURO_ZONE_COUNTRIES = [
  "AT",
  "BE",
  "CY",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PT",
  "SK",
  "SI",
  "ES",
  "BG",
  "HR",
  "CZ",
  "DK",
  "HU",
  "IS",
  "LI",
  "NO",
  "PL",
  "RO",
  "SE",
];

export const currencySymbolMapper: Record<CurrencyType, string> = {
  USD: "$",
  EUR: "€",
  CHF: "CHF",
};

export const getCurrencyFromCountryCode = (
  countryCode: string | undefined | null
): CurrencyType => {
  if (!countryCode) return "USD";

  const normalized = countryCode.toUpperCase();

  if (normalized === "CH") return "CHF";
  if (EURO_ZONE_COUNTRIES.includes(normalized)) return "EUR";

  return "USD";
};

export const formatPrice = (
  amount: number | string,
  currency: CurrencyType
): string => {
  if (currency === "EUR") return `${amount} ${currencySymbolMapper.EUR}`;
  if (currency === "CHF") return `${currencySymbolMapper.CHF} ${amount}`;
  return `${currencySymbolMapper.USD}${amount}`;
};
